import { render, staticRenderFns } from "./PreChatFields.vue?vue&type=template&id=cf676de4&scoped=true&"
import script from "./PreChatFields.vue?vue&type=script&lang=js&"
export * from "./PreChatFields.vue?vue&type=script&lang=js&"
import style0 from "./PreChatFields.vue?vue&type=style&index=0&id=cf676de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf676de4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf676de4')) {
      api.createRecord('cf676de4', component.options)
    } else {
      api.reload('cf676de4', component.options)
    }
    module.hot.accept("./PreChatFields.vue?vue&type=template&id=cf676de4&scoped=true&", function () {
      api.rerender('cf676de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/PreChatForm/PreChatFields.vue"
export default component.exports